import React from "react";
import "./Coin.css";

const Coin = ({ name, image, symbol, price, volume, priceChange }) => {
  return (
    <div className="coin-container">
      <div className="coin-row">
        <div className="coin">
          <img src={image} alt="cypto" />
          <h1 className="name">{name}</h1>

          <p className="coin-symbol">{symbol}</p>
        </div>
        <div className="coin-data">
          <p className="coin-price">{price.toLocaleString()} ₹</p>
          <p className="coin-volume">{volume.toLocaleString()} ₹</p>
          {priceChange < 0 ? (
            <p className="coin-percentage red">{priceChange.toFixed(2)}%</p>
          ) : (
            <p className="coin-percentage green" style={{ color: "#11d811" }}>
              {priceChange.toFixed(2)}%
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Coin;
